import React from 'react';

import ExternalReportsTabs from './ExternalReportsTabs';

const ExternalReports = () => {
  return <ExternalReportsTabs />;
};

export default ExternalReports;
